import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { PortableApplianceTest } from '../models/portable-appliance-test/portable-appliance-test';
import { PortableApplianceTestPost } from '../models/portable-appliance-test/portable-appliance-test-post';
import { PortableApplianceTestOverview } from '../models/portable-appliance-test/portable-appliance-test-overview';
import { FileService } from "./file.service";
import { PropertyServicesSummary } from "../models/property-services/property-services-summary.interface";
import { mergeMap, tap } from "rxjs/operators";
import {
    OwnerPortableApplianceTestOverview
} from "../models/portable-appliance-test/owner-portable-appliance-test-overview";

@Injectable()
export class PortableApplianceTestService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getOverview(propertyReference: string): Observable<PortableApplianceTestOverview> {
        return this.http.get<PortableApplianceTestOverview>(`${this.configService.baseUrl}/manage/property/${propertyReference}/portable-appliance-tests/overview`);
    }

    getPastList(propertyReference: string): Observable<PortableApplianceTest[]> {
        return this.http.get<PortableApplianceTest[]>(`${this.configService.baseUrl}/manage/property/${propertyReference}/portable-appliance-tests/past`);
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<PortableApplianceTest>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/portable-appliance-tests/${guid}`);
    }

    add(organisationReference: string, model: PortableApplianceTestPost): Observable<PortableApplianceTest> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<PortableApplianceTest>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/portable-appliance-tests`, model))
        );
    }
    remove(propertyReference: string, item: PortableApplianceTest): Observable<boolean> {
        return this.http.delete<boolean>(`${this.configService.baseUrl}/manage/property/${propertyReference}/portable-appliance-tests/${item.guid}`);
    }

    getSummary(propertyReference: string) {
        return this.http.get<PropertyServicesSummary>(`${this.configService.baseUrl}/manage/property/${propertyReference}/portable-appliance-tests/summary`);
    }

    getOwnerOverview(propertyReference: string): Observable<OwnerPortableApplianceTestOverview> {
        return this.http.get<OwnerPortableApplianceTestOverview>(`${this.configService.baseUrl}/owner/property/${propertyReference}/portable-appliance-tests/overview`);
    }

    getOwnerList(propertyReference: string): Observable<PortableApplianceTest[]> {
        return this.http.get<PortableApplianceTest[]>(`${this.configService.baseUrl}/owner/property/${propertyReference}/portable-appliance-tests`);
    }
}
